import styled, { CSSObject } from '@emotion/styled'
import { themedValue } from '../../../__styling/themed-value'
import { keyframes } from '@emotion/css'
import { TheWestLiveBroadcast } from '@news-mono/web-common'

const wavesTheWest = require('../TheWestLiveWaves/assets/waves-1-tw.svg')
const waves2TheWest = require('../TheWestLiveWaves/assets/waves-2-tw.svg')
const wavesPerthNow = require('../TheWestLiveWaves/assets/waves-1-pn.svg')
const waves2PerthNow = require('../TheWestLiveWaves/assets/waves-2-pn.svg')
const wavesCatchup = require('../TheWestLiveWaves/assets/waves-1-catchup.svg')

interface StyledWaveProps {
    broadcast?: TheWestLiveBroadcast
}

const commonWavesStyles: CSSObject = {
    backgroundPosition: 'bottom left',
    backgroundRepeat: 'repeat no-repeat',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    transformOrigin: 'center bottom',
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: '100%',
    width: '200%',
    opacity: 0.1,
    backgroundSize: '50% auto',
    pointerEvents: 'none',
    animationName: keyframes({
        '0%': {
            transform: `translateX(0) translateZ(0) scaleY(1)`,
        },
        '25%': {
            transform: `translateX(-12.5%) translateZ(0) scaleY(0.55)`,
        },
        '50%': {
            transform: `translateX(-25%) translateZ(0) scaleY(1.15)`,
        },
        '75%': {
            transform: `translateX(-37.5%) translateZ(0) scaleY(0.25)`,
        },
        '100%': {
            transform: `translateX(-50%) translateZ(0) scaleY(1)`,
        },
    }),

    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
    },
}

export const StyledWestLiveWaves = styled('div')<StyledWaveProps>(
    {
        ...commonWavesStyles,
        animationDuration: '10s',
    },
    ({ theme, broadcast }) => ({
        backgroundImage: themedValue(theme, {
            thewest:
                broadcast === 'catchup'
                    ? `url(${wavesCatchup})`
                    : `url(${wavesTheWest})`,
            perthnow:
                broadcast === 'catchup'
                    ? `url(${wavesCatchup})`
                    : `url(${wavesPerthNow})`,
            fallback: undefined,
        }),
    }),
)

export const StyledWestLiveWaves2 = styled('div')<StyledWaveProps>(
    {
        ...commonWavesStyles,
        animationDuration: '15s',
        animationDelay: '-1s',
    },
    ({ theme, broadcast }) => ({
        backgroundImage: themedValue(theme, {
            thewest:
                broadcast === 'catchup'
                    ? `url(${wavesCatchup})`
                    : `url(${waves2TheWest})`,
            perthnow:
                broadcast === 'catchup'
                    ? `url(${wavesCatchup})`
                    : `url(${waves2PerthNow})`,
            fallback: undefined,
        }),
    }),
)

export const StyledWestLiveWaves3 = styled(StyledWestLiveWaves)({
    backgroundPosition: '-30% auto',
    animationDuration: '18s',
    animationDelay: '-3s',
})
